import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useLicsSchedule = () => {
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  const { MEDICARE_LICS_SCHEDULE_DETAIL } = ROUTE_PATHS;
  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSchedules = [],
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      lscLicsScheduleName: "",
    },
    selectMode: initialSelectMode = false,
  } = currentState;

  const [data, setData] = useState([]);
  const [paramsData, setParamsData] = useState(initialParamsData);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentYearFetch, setCurrentYearFetch] = useState(false);
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [selectModeData, setSelectModeData] = useState({});

  const toast = useToast();

  const screen_title = "LICS Schedule";
  const screenNumber = "RCLSC001";

  const formFields = [
    {
      fieldLabel: "LSC LICS Schedule Name",
      name: "lscLicsScheduleName",
      label: "Schedule",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "LCS LICS Schedule Desc",
      name: "lcsLicsScheduleDesc",
      label: "Description",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 25,
    },
  ];

  const dropdownOptions = [];

  // const handleBack = useCallback(() => {
  //     if (currentIndex < selectedSchedules.length - 1) {
  //         setCurrentIndex(currentIndex + 1);
  //     } else {
  //         navigateToPage(previousScreen, previousState);
  //     }
  // }, [currentIndex, selectedSchedules]);

  // const leftButtons = [{ button_label: 'Back', button_handeler: handleBack, button_key: "F12" }];

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "initData") {
      const { selectMode, data: paramData, showBack } = data;
      setSelectMode(true); // (selectMode);
      setSelectModeData(paramData.params);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const leftButtons = selectMode
    ? [
        {
          button_label: "Back",
          button_handeler: () => {
            const message = {
              type: "hideModal",
            };
            window.parent.postMessage(message, "*");
          },
          button_key: "F12",
        },
      ]
    : [];

  const ctaButtons = [
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const menuOptions = [
    {
      label: "Phases",
      icon: <span className="material-icons">list</span>,
      command: () => {
        const selectedSchedules = selectedRows.length
          ? selectedRows
          : [rowData];
        const lastSchedule = selectedSchedules[selectedSchedules.length - 1];
        const updatedParamsData = {
          ...paramsData,
          lscLicsScheduleName: lastSchedule.lscLicsScheduleName,
        };

        navigateToPage(MEDICARE_LICS_SCHEDULE_DETAIL, [
          { paramsData: updatedParamsData, selectMode: selectMode },
          {
            selectedSchedules: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            displayMode: true,
            currentIndex: 0,
          },
        ]);
      },
    },
  ];

  const columnDef = [
    {
      header: "Schedule",
      field: "lscLicsScheduleName",
    },
    {
      header: "Description",
      field: "lcsLicsScheduleDesc",
    },
    {
      header: "Phases",
      field: "countField",
    },
  ];

  const parmKey = "lscLicsScheduleName";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/lscLicsScheduleCtl`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData({
      dropDowns: dropdownOptions.map(
        (item) => item.field_label + item.condition
      ),
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage]);

  const fetchCurrentYear = async () => {
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/accumsDate/currentYear"
      );
      const currentYear = response.responseData;
      setParamsData((prevParams) => ({
        ...prevParams,
        lscLicsScheduleName: currentYear,
      }));
      setCurrentYearFetch(true);
    } catch (error) {
      console.error("Error fetching current year:", error);
    }
  };

  useEffect(() => {
    if (!paramsData.lscLicsScheduleName && !currentYearFetch) {
      fetchCurrentYear();
    }
  }, [paramsData, currentYearFetch]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteLicsSchedule = () => {
    if (selectedOption === "yes") {
      const params = { lscLicsScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/licsschedule", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/lscLicsScheduleCtl/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteLicsSchedule,
    setSelectedOption,
    leftButtons,
  };
};

export default useLicsSchedule;
